import { render, staticRenderFns } from "./Sql.vue?vue&type=template&id=4c71e97a&"
import script from "./Sql.vue?vue&type=script&lang=js&"
export * from "./Sql.vue?vue&type=script&lang=js&"
import style0 from "./Sql.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports